import React from 'react';

const colorMap: Record<string, { dot: string; bg: string; text: string }> = {
  // Orders
  'New': { dot: 'bg-blue-500', bg: 'bg-blue-50', text: 'text-blue-700' },
  'Processing': { dot: 'bg-amber-500', bg: 'bg-amber-50', text: 'text-amber-700' },
  'Fulfilled': { dot: 'bg-emerald-500', bg: 'bg-emerald-50', text: 'text-emerald-700' },
  'Cancelled': { dot: 'bg-gray-400', bg: 'bg-gray-100', text: 'text-gray-500' },
  // Inquiries
  'Responded': { dot: 'bg-emerald-500', bg: 'bg-emerald-50', text: 'text-emerald-700' },
  'Closed': { dot: 'bg-gray-400', bg: 'bg-gray-100', text: 'text-gray-500' },
  // Invoices
  'draft': { dot: 'bg-gray-400', bg: 'bg-gray-100', text: 'text-gray-600' },
  'sent': { dot: 'bg-blue-500', bg: 'bg-blue-50', text: 'text-blue-700' },
  'paid': { dot: 'bg-emerald-500', bg: 'bg-emerald-50', text: 'text-emerald-700' },
  'overdue': { dot: 'bg-red-500', bg: 'bg-red-50', text: 'text-red-700' },
  // Availability
  'AVAILABLE': { dot: 'bg-emerald-500', bg: 'bg-emerald-50', text: 'text-emerald-700' },
  'PREORDER': { dot: 'bg-amber-500', bg: 'bg-amber-50', text: 'text-amber-700' },
  'SOLD OUT': { dot: 'bg-red-500', bg: 'bg-red-50', text: 'text-red-700' },
  'ARCHIVED': { dot: 'bg-gray-400', bg: 'bg-gray-100', text: 'text-gray-500' },
  // Contracts
  'active': { dot: 'bg-emerald-500', bg: 'bg-emerald-50', text: 'text-emerald-700' },
  'fulfilled': { dot: 'bg-blue-500', bg: 'bg-blue-50', text: 'text-blue-700' },
  'cancelled': { dot: 'bg-red-400', bg: 'bg-red-50', text: 'text-red-600' },
  // Offers
  'accepted': { dot: 'bg-emerald-500', bg: 'bg-emerald-50', text: 'text-emerald-700' },
  'declined': { dot: 'bg-red-400', bg: 'bg-red-50', text: 'text-red-600' },
  // Change requests
  'open': { dot: 'bg-amber-500', bg: 'bg-amber-50', text: 'text-amber-700' },
  'resolved': { dot: 'bg-emerald-500', bg: 'bg-emerald-50', text: 'text-emerald-700' },
};

const fallback = { dot: 'bg-gray-400', bg: 'bg-gray-100', text: 'text-gray-600' };

export const StatusBadge: React.FC<{ status: string }> = ({ status }) => {
  const c = colorMap[status] || fallback;
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold tracking-wide ${c.bg} ${c.text}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />
      {status}
    </span>
  );
};
